// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"45d7b026","453":"beab3bc8","745":"62eb2547"}[chunkId] + ".chunk.js";
};